import React, {Component} from 'react';
import SkipToContentMenuContext from '../SkipToContentMenuContext';
import SkipToContentMenuAnchorInner from './SkipToContentMenuAnchorInner';

class SkipToContentMenuAnchor extends Component {
    render() {
        return (
            <SkipToContentMenuContext.Consumer>
                {(context = {}) => {
                    const {addMenuItem, removeMenuItem} = context;

                    return (
                        <SkipToContentMenuAnchorInner
                            {...this.props}
                            addMenuItem={addMenuItem}
                            removeMenuItem={removeMenuItem}
                        />
                    );
                }}
            </SkipToContentMenuContext.Consumer>
        );
    }
}

export default SkipToContentMenuAnchor;